//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        searchString: '',
        status: [],
        createdFrom: '',
        createdTo: '',
        priceFrom: '',
        priceTo: '',
        currency: '',
      },
      constant,
    };
  },

  computed: {
    ...mapState('merchantsProducts', ['filterLists']),
    ...mapState('currencies', ['currencies']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('merchantsProducts', ['setFilters']),
  },
};
